export enum UserStatus {
    Locked = 'USER_STATUS_LOCKED',
    NoUser = 'USER_STATUS_NO_USER',
    ShopUser = 'USER_STATUS_SHOP_USER',
    ShopAdmin = 'USER_STATUS_SHOP_ADMIN',
    SupplierUser = 'USER_STATUS_SUPPLIER_USER',
    SupplierAdmin = 'USER_STATUS_SUPPLIER_ADMIN',
    NotActivated = 'USER_STATUS_NOT_ACTIVATED',
}
